import { Dialog } from './Dialog';

interface Props {
  readonly filename: string;
  readonly errors: readonly string[];
  readonly onClose: () => void;
}

/**
 * Validation failures, shown as field paths. Deliberately never shows the file's
 * contents.
 */
export function ImportResultDialog({ filename, errors, onClose }: Props) {
  return (
    <Dialog
      title="That file could not be imported"
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="prose">
        <p>
          Nothing was changed. <strong>{filename}</strong> failed these checks:
        </p>
      </div>
      <ul className="error-list">
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
      <div className="prose" style={{ marginTop: 14 }}>
        <p>
          Only JSON exported by this app can be imported. Files from other whiteboard tools are not
          supported, by design.
        </p>
      </div>
    </Dialog>
  );
}
